import React from "react";
import { useUser } from "../../../../context/AuthContext";
import Scope3ApprovalListCore from "../Scope3ApprovalListCore";
import SimpleScope3ApprovalDrawer from "../SimpleScope3ApprovalDrawer";
import { formatDateCell, formatValueUnitField } from "../approvalTableFormatters";

const mapProcessingApprovalRow = (item) => ({
  ...item,
  soldProductDateDisplay: formatDateCell(item?.soldProductDate),
  quantitySoldDisplay: formatValueUnitField(item?.quantitySold),
  productName:
    item?.productName ??
    item?.productMaster?.productName ??
    item?.product?.productName ??
    "",
  vendorName:
    item?.vendorName ??
    item?.customerMaster?.customerVendorName ??
    "",
  requestStatus: item?.requestStatus ?? item?.approvalStatus ?? "",
});

/** Hide technical / energy detail rows in the approval diff table (names match `editValue` keys). */
const PROCESSING_OF_SOLD_EDIT_VALUE_KEYS_OMIT = [
  "energyConsumptionForProcessing",
  // "electricityConsumption",
  "energySourceForProcessing",
  "fuelType",
  "fuelConsumption",
  "fuelConsumptionUnit",
  "fuelType2",
  "fuelConsumption2",
  "fuelConsumptionUnit2",
  // "fuelEntries",
  "productMasterId",
  "customerMasterId",
];

const ProcessingView = (props) => (
  <SimpleScope3ApprovalDrawer
    {...props}
    title="Processing of sold products — change request"
    omitEditValueKeys={PROCESSING_OF_SOLD_EDIT_VALUE_KEYS_OMIT}
  />
);

const ProcessingOfSoldProductsApproval = () => {
  const { user } = useUser();

  const headings = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin ? { title: "Facility", key: "facilityName" } : null,
    { title: "Sold Product Date", key: "soldProductDateDisplay" },
    { title: "Product Name", key: "productName" },
    { title: "Customer/Vendor Name", key: "vendorName" },
    // { title: "Quantity Sold", key: "quantitySoldDisplay" },
    { title: "Status", key: "requestStatus" },
    { title: "Created By", key: "createdBy" },
  ].filter(Boolean);

  return (
    <Scope3ApprovalListCore
      pageTitle="Processing of Sold Products"
      apiSegment="processingOfSoldProducts"
      ViewPage={ProcessingView}
      headings={headings}
      columnWidth={
        user?.companyAdmin
          ? "10% 10% 12% 14% 14% 12% 12% 8%"
          : "11% 14% 16% 16% 14% 14% 8%"
      }
      mapRow={mapProcessingApprovalRow}
    />
  );
};

export default ProcessingOfSoldProductsApproval;
